export default class Ajaxify {
  constructor(userCallbackOnRequest, userCallbackOnRender) {
    this.mainContentQuery = '.main';
    this.secondaryNavQuery = '.js-secondary-nav';

    this.callbackOnRequest = userCallbackOnRequest;
    this.callbackOnRender = userCallbackOnRender;
    this.currentAjaxRequest = null;

    this.rootUrl = this.constructor.getRootUrl();

    this.$html = document.querySelector('html');
    this.$body = document.querySelector('body');
    this.$content = document.querySelector(this.mainContentQuery);
    this.$secondaryNav = document.querySelector(this.secondaryNavQuery);

    // replace current state to get history to work on the first page.
    const content = document.documentElement.outerHTML;
    const url = document.location.href;
    window.history.replaceState({
      content,
      url,
    }, '', url);

    // setup click event for internal links.
    this.#setupStateListners();

    // only have to ajaxfy the body.
    this.#ajaxify(document.body);
  }

  // convert html string to Dom elements.
  static documentHtml(html) {
    const result = String(html).replace(/<!DOCTYPE[^>]*>/i, '');
    const parser = new DOMParser();
    const doc = parser.parseFromString(result, 'text/html');
    return doc;
  }

  static getRootUrl() {
    const { port, protocol } = document.location;
    const host = document.location.hostname || document.location.host;
    let url = `${protocol}//${host}`;
    if (port) {
      url += `:${port}`;
    }
    return url;
  }

  // old school ajax request for better backwards compatibility.
  static ajax(url, callback) {
    // if there is a current ajax request abort it.
    if (this.currentAjaxRequest) {
      this.currentAjaxRequest.abort();
    }

    // create new ajax request.
    this.currentAjaxRequest = new XMLHttpRequest();
    this.currentAjaxRequest.onreadystatechange = () => {
      if (this.currentAjaxRequest.readyState === XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
        if (this.currentAjaxRequest.status === 200) {
          callback(this.currentAjaxRequest.responseText);

          this.currentAjaxRequest = null;
        } else {
          // hard refresh with new url
          document.location.href = url;
        }
      }
    };

    this.currentAjaxRequest.open('GET', url, true);
    this.currentAjaxRequest.send();
  }

  // takes pageHtml and updates the current page with the new content.
  #changePage(pageHtml, url, push) {
    const $data = this.constructor.documentHtml(pageHtml);
    const $dataBody = $data.querySelector('body');
    const $dataContent = $dataBody.querySelector(this.mainContentQuery);
    const $dataSecondaryNav = $dataBody.querySelector(this.secondaryNavQuery);

    // Isolate the content
    const contentHtml = $dataContent.innerHTML || $dataBody.innerHTML || $data.innerHTML;
    const secondaryNavHtml = $dataSecondaryNav.innerHTML || '';

    // If empty hard reload page.
    if (!contentHtml) {
      document.location.href = url;
      return false;
    }

    // push new state.
    if (push) {
      window.history.replaceState({
        content: pageHtml,
        url,
      }, '', url);
    }

    // Update the body classes
    this.$body.setAttribute('class', $dataBody.getAttribute('class'));

    // Update the content
    // this.$content.html(contentHtml);
    this.$content.innerHTML = contentHtml;
    this.$secondaryNav.innerHTML = secondaryNavHtml;

    // update the secondary content.

    // ajaxify the new content
    this.#ajaxify(this.$content);
    this.#ajaxify(this.$secondaryNav);

    // grab the new title, and update the current page title.
    document.title = $data.querySelector('title').innerText;
    try {
      const newTitle = document.title.replace('<', '&lt;').replace('>', '&gt;').replace(' & ', ' &amp; ');
      document.getElementsByTagName('title')[0].innerHTML = newTitle;
    } catch (Exception) {
      // ignore
    }

    // scroll to top of page on push state.
    if (push) {
      window.scrollTo(0, 0);
    }

    return true;
  }

  // Add a new page to the history, starts loading animation, and fetches the new page.
  #pushNewPage(url) {
    this.$html.classList.add('loading'); // Set Loading
    this.$content.classList.add('fadeout-hidden'); // add transition class.
    this.callbackOnRequest(url); // Call before ajax request.

    window.history.pushState({
      content: null,
      url,
    }, '', url);

    // Ajax Request the Traditional Page
    this.constructor.ajax(url, (data) => {
      this.#changePage(data, url, true);

      // Call on render Callback.
      this.callbackOnRender();

      this.$html.classList.remove('loading');
      this.$content.classList.remove('fadeout-hidden');

      // $window.trigger(completedEventName);
    });
  }

  #handelInternalPageClick(event) {
    // don't follow link.
    event.preventDefault();

    // Prepare
    const $this = event.currentTarget;
    let url = $this.href;

    // fix url if it is a relative url without a protocol.
    if (url.substring(0, 2) === '//') {
      url = document.location.protocol + url;
    }

    // Continue as normal for cmd clicks etc
    if (event.which === 2 || event.metaKey) {
      console.log('cmd click');
      return;
    }

    this.#pushNewPage(url);
  }

  #ajaxify($currentHtml) {
    // get internal links.
    const $links = $currentHtml.querySelectorAll('a');
    const $internalLinks = [];
    for (let i = 0, l = $links.length; i < l; i += 1) {
      const $link = $links[i];
      let url = $link.href || '';

      // adds protocol to url if missing.
      if (url.substring(0, 2) === '//') {
        url = document.location.protocol + url;
      }

      // Check if internal link
      let isInternalLink = url.substring(0, this.rootUrl.length) === this.rootUrl || url.indexOf(':') === -1;
      if (isInternalLink) {
        if ($link.classList.contains('no-ajax')) {
          isInternalLink = false;
        } else if ($link.classList.contains('post-edit-link')) {
          isInternalLink = false;

        // check if it's the same pages
        } else if ($link.href.startsWith('#')) {
          isInternalLink = false;
        } else if ($link.href.split('#')[0] === document.location.href.split('#')[0]) {
          isInternalLink = false;
        }
      }

      // colect internal link into a list.
      if (isInternalLink) {
        $internalLinks.push($link);
      }
    }

    for (let i = 0, l = $internalLinks.length; i < l; i += 1) {
      const $internalLink = $internalLinks[i];

      // console.log($internalLink);

      // setup click event. bind this to the event.
      $internalLink.addEventListener('click', this.#handelInternalPageClick.bind(this)); // end click listner.
    }
  }

  // handel state changes such as forward and back.
  #setupStateListners() {
    // Hook into State Changes
    window.addEventListener('popstate', (event) => {
      const url = document.location.href;

      // if url missmatch history reload page completely.
      if (event.state.url !== url) {
        document.location.href = url;
      }

      // $html.classList.add('loading'); // Set Loading
      // this.$content.classList.add('fadeout-hidden'); // add transition class.

      this.callbackOnRequest(url); // Call before ajax request.

      // check if page content is empty.
      if (!event.state.content) {
        this.constructor.ajax(url, (data) => {
          this.#changePage(data, url, false);
        });
      } else {
        // other wise load it from history.
        this.#changePage(event.state.content, url, false);
      }

      // Call on render Callback.
      this.callbackOnRender();

      // $html.classList.remove('loading');
      // this.$content.classList.remove('fadeout-hidden');
    });
  }
}
